import { TableColumn } from '@vsolv/vectors/table';
import { CheckboxCellComponent, CheckboxCellProps } from './checkbox-cell.component';

/** Row-selection column for vs-table. The header stays empty — vs-table renders headers as plain text. */
export class CheckboxColumn<I> extends TableColumn<I, CheckboxCellProps> {
  readonly component = CheckboxCellComponent;
}
